var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"bank-text",attrs:{"xs12":""}},[_vm._v("Personal Guarantee File Location: "+_vm._s(_vm.personalGuaranteeFileLocation))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }